<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="130px">
                <el-form-item label="任务名称" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                   <el-form-item label="任务编号" prop="FNo" v-if="false">
                    <el-input v-model="form.FNo"></el-input>
                </el-form-item>
                  <el-form-item label="所属项目" prop="FProjectId">
                        <sy-select v-model="form.FProjectId" @change="projectChange"
                                   optionData="server/business/Project.ashx?cmd=GetOptions">
                        </sy-select>
                 </el-form-item>
                 <el-form-item label="项目阶段" prop="FProjectDetailId">
                        <sy-cascader v-model="form.FProjectDetailId" @change="changeprojectdetail"
                                   :optionsData="'server/business/Project.ashx?cmd=GetDetailOptionsTree&FProjectId='+(form.FProjectId?form.FProjectId:0)">
                        </sy-cascader>
                  </el-form-item>
                 <el-form-item label="所属部门" prop="FDeptId">
                        <sy-select v-model="form.FDeptId" 
                                   optionData="server/system/Dept.ashx?cmd=GetOptions">
                        </sy-select>
                 </el-form-item>
                 <el-form-item label="接收人" prop="FReciverId">
                        <sy-select v-model="form.FReciverId"
                                   :optionData="'server/system/Staff.ashx?cmd=GetStafOptions&FDeptId='+(form.FDeptId?form.FDeptId:0)">
                        </sy-select>
                  </el-form-item>
                   <el-form-item  label="任务分类（型号）" prop="FTypeId2" v-if="false">
                     <sy-select v-model="form.FTypeId2"
                                   :optionData="'server/business/DutyMould.ashx?cmd=GetModelOptions&FParentId='+(form.FTypeId?form.FTypeId:0)">
                    </sy-select>
                   </el-form-item> 
                  <el-form-item label="任务模板" prop="FMouldId" v-if="false"> 
                    <sy-select v-model="form.FMouldId" @change="changemould"
                               :optionData="'server/business/DutyMould.ashx?cmd=GetOptions&FTypeId='+(form.FTypeId2?form.FTypeId2:0)">
                    </sy-select>
                 </el-form-item>
                   <el-form-item label="计划数量" prop="FPlanNum" >
                    <el-input type="number" v-model="form.FPlanNum" @input="changeplannum"></el-input>
                 </el-form-item>
                    <el-form-item label="标准用时(秒)" prop="FSTDTime">
                    <el-input style="width:20%;" type="number" v-model="hours" min="0"></el-input>时
                    <el-input style="width:20%;"  type="number" v-model="minutes" min="0"></el-input>分
                 </el-form-item>
                 <el-form-item label="开始时间" prop="FStartTime" >
                    <el-date-picker type="datetime" placeholder="选择时间" v-model="form.FStartTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="结束时间" prop="FEndTime" >
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="form.FEndTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="是否外协任务" prop="FIsOutsource" v-if="false">
                   <el-radio-group v-model="form.FIsOutsource">
                        <el-radio :label="0" >否</el-radio>
                        <el-radio :label="1" >是</el-radio> 
                    </el-radio-group>
                </el-form-item>
                  <el-form-item label="优先级" prop="FPriority" >
                   <el-radio-group v-model="form.FPriority">
                        <el-radio :label="0" >普通</el-radio>
                        <el-radio :label="1" >紧急</el-radio> 
                    </el-radio-group>
                </el-form-item>
                   <el-form-item label="审核人" prop="FAuditUserId" v-if="form.FID>0">
                        <sy-select v-model="form.FAuditUserId"
                                   optionData="server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0">
                        </sy-select>
                  </el-form-item>
                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
     import Vue from 'vue'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '任务名称', trigger: 'blur'}],
                    
                     FReciverId: [{required: true,message: '接收人', trigger: 'blur'}],
                    FStartTime: [{required: true,message: '开始时间', trigger: 'blur'}],
                    FEndTime: [{required: true,message: '结束时间', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false,
                mouldSTDTime:0,
                hours:0,
                minutes:0,
            }
        },
        methods: {
            _openEdit(record) {      
                this.editFormVisible = true;
                this.form = Object.assign({},record);
                this.mouldSTDTime = record.mouldSTDTime
                this.hours = Math.trunc(record.FSTDTime/60)
                this.minutes = Math.trunc((record.FSTDTime-(60*this.hours)))   
                if(record.projectdetailPId!=0){
                    let arr=[]
                    arr.push(record.projectdetailPId)
                    arr.push(record.FProjectDetailId)
                    this.form.FProjectDetailId = arr
                }  
               
            },
            _openAdd(record) {
                debugger
                this.editFormVisible = true;
                this.form = {FID:0,FMouldId:0,FProgress:0,FDeptId:0,FReciverId:0,FProjectDetailId:0,FProjectId:0,FTiming:0,FStatus:0,FIsOutsource:0,FPriority:0,FTypeId:0,FTypeId2:0};
                if(record.FProjectId){
                    this.form.FProjectId = record.FProjectId
                       console.log(record)
                        Vue.nextTick(()=>{ 
                            setTimeout(()=>{
                              this.form.FProjectDetailId=record.FProjectDetailId?record.FProjectDetailId:0
                              if(record.detail){
                                 this.mouldSTDTime = record.detail.FSTDTime
                                 if(record.detail.FIsTask==1){
                                    this.form.FName = record.detail.FName
                                }
                              }
                        },1200)
                        })
                }   
            },
            switchLoading(flag){
                this.loading = flag;
            },
            save:function () {
                   if(this.form.FStartTime>this.form.FEndTime){
                      util.msgWarning("开始时间不能大于结束时间")
                      return
                }
                if(this.hours==''||this.hours<0) this.hours=0
                if(this.minutes==''||this.minutes<0) this.minutes=0
                this.form.FSTDTime = parseInt(this.hours*60)+parseInt(this.minutes)
                if(this.form.FProjectDetailId.length==2){
                    this.form.FProjectDetailId = this.form.FProjectDetailId[1]
                }
                else{
                     this.form.FProjectDetailId = this.form.FProjectDetailId[0]
                }
                util.saveForm("server/business/Duty.ashx?cmd=Save",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            },
             projectChange(val){
                  this.form.FProjectDetailId=0
                 /* if(val&&val!=0){
                  let _that = this
                  let url = "server/business/Project.ashx?cmd=GetDutyMouldByProject"
                  util.get(url,{FID:val},this.switchLoading,result=> {
                     _that.form.FTypeId= result.FTypeId
                     _that.form.FTypeId2 = result.FTypeId2
                    _that.form.FDeptId = result.FDeptId
                  })
                }*/
            },
            deptChange(val){
                  this.form.FReciverId=0
                  this.form.FTypeId2=0
                  if(val){
                  let _that = this
                  let url = "server/business/DutyMould.ashx?cmd=GetDutyMouldTypeByDept"
                  util.get(url,{FID:val},this.switchLoading,result=> {
                     _that.form.FTypeId= result.FTypeId
                  })
                  }
            },
            changeprojectdetail(val,record){
               if(record.FSTDTime&&this.form.FPlanNum){
                    this.form.FSTDTime = this.form.FPlanNum*record.FSTDTime/60.00
                    this.hours = Math.trunc(this.form.FSTDTime/60)
                    this.minutes = Math.trunc((this.form.FSTDTime-(60*this.hours)))   
               }
               
               this.mouldSTDTime = record.FSTDTime
               if(record.FIsTask==1){
                  this.form.FName = record.label
               }
            },
           changeplannum(val){
                 if(this.mouldSTDTime&&this.form.FPlanNum){
                    this.form.FSTDTime = this.form.FPlanNum*this.mouldSTDTime/60.00
                    this.hours = Math.trunc(this.form.FSTDTime/60)
                    this.minutes = Math.trunc((this.form.FSTDTime-(60*this.hours)))   
               }
            }
          },
            mounted() {
             
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Duty_Edit.vue